<teleport to="body">
  <div v-if="is_visible" class="modal fade show" @click="close_modal"></div>
  <div v-if="is_visible" class="modal show d-block" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered" @click.stop>
      <div class="modal-content">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title d-flex align-items-center">
            <p class="text-white">Assign Questions — {{ selected_rule?.name || "" }}</p>
          </h5>
          <button type="button" class="btn-close modal-close-btn" @click="close_modal" aria-label="Close"></button>
        </div>

        <div class="modal-body py-3">
          <div class="row">
            <!-- LEFT: Assign Questions -->
            <div class="col-lg-6 border-end">
              <h6 class="text-xs fw-bold mb-3"><i class="fas fa-plus-circle me-2 text-primary"></i>Assign Questions</h6>

              <div v-if="is_loading_forms" class="text-center py-4">
                <div class="spinner-border spinner-border-sm"></div>
              </div>

              <div v-else>
                <!-- Step 1: Form Selection -->
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label text-xxs fw-medium mb-0">
                      <span class="badge bg-primary me-1">1</span> Form
                    </label>
                    <button
                      v-if="selected_form_id && main_sections.length"
                      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                      @click="assign_all_form_questions"
                      :disabled="is_bulk_assigning"
                    >
                      <span v-if="is_bulk_assigning" class="spinner-border spinner-border-sm me-1"></span>
                      <i v-else class="fas fa-layer-group me-1"></i>Assign All Form Questions
                    </button>
                  </div>
                  <select class="form-select form-select-sm text-xxs" v-model="selected_form_id" @change="load_main_sections">
                    <option value="" disabled hidden>Select Form</option>
                    <option v-for="form in available_forms" :key="form.id" :value="form.id">{{ form.form_name }}</option>
                  </select>
                </div>

                <!-- Step 2: Main Section Selection -->
                <div class="mb-3" v-if="selected_form_id">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label text-xxs fw-medium mb-0">
                      <span class="badge bg-primary me-1">2</span> Main Section
                    </label>
                    <button
                      v-if="selected_main_section_id && sub_sections.length"
                      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                      @click="assign_all_main_section_questions"
                      :disabled="is_bulk_assigning"
                    >
                      <span v-if="is_bulk_assigning" class="spinner-border spinner-border-sm me-1"></span>
                      <i v-else class="fas fa-layer-group me-1"></i>Assign All Main Section
                    </button>
                  </div>
                  <div v-if="is_loading_main_sections" class="text-center py-2">
                    <div class="spinner-border spinner-border-sm"></div>
                  </div>
                  <select v-else class="form-select form-select-sm text-xxs" v-model="selected_main_section_id" @change="load_sub_sections">
                    <option value="" disabled hidden>Select Main Section</option>
                    <option v-for="main_section in main_sections" :key="main_section.id" :value="main_section.id">
                      {{ main_section.main_section?.name || `Section ${main_section.id}` }}
                    </option>
                  </select>
                </div>

                <!-- Step 3: Sub-Section Selection -->
                <div class="mb-3" v-if="selected_main_section_id">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <label class="form-label text-xxs fw-medium mb-0">
                      <span class="badge bg-primary me-1">3</span> Sub-Section
                    </label>
                    <button
                      v-if="selected_sub_section_id && question_list.length"
                      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                      @click="assign_all_sub_section_questions"
                      :disabled="is_bulk_assigning"
                    >
                      <span v-if="is_bulk_assigning" class="spinner-border spinner-border-sm me-1"></span>
                      <i v-else class="fas fa-layer-group me-1"></i>Assign All Sub-Section
                    </button>
                  </div>
                  <div v-if="is_loading_sub_sections" class="text-center py-2">
                    <div class="spinner-border spinner-border-sm"></div>
                  </div>
                  <select v-else class="form-select form-select-sm text-xxs" v-model="selected_sub_section_id" @change="load_questions">
                    <option value="" disabled hidden>Select Sub-Section</option>
                    <option v-for="sub_section in sub_sections" :key="sub_section.id" :value="sub_section.id">
                      {{ sub_section.section?.name || `Sub-Section ${sub_section.id}` }}
                    </option>
                  </select>
                </div>

                <!-- Step 4: Questions List -->
                <div v-if="selected_sub_section_id">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <label class="form-label text-xxs fw-medium mb-0">
                      <span class="badge bg-primary me-1">4</span> Questions
                    </label>
                    <input type="text" class="form-control form-control-sm text-xxs w-50" placeholder="Search..." v-model="question_search" />
                  </div>
                  <div v-if="is_loading_questions" class="text-center py-3">
                    <div class="spinner-border spinner-border-sm"></div>
                  </div>
                  <div v-else-if="filtered_questions.length" class="list-group list-group-flush questions-list-container">
                    <div
                      v-for="section_question in filtered_questions"
                      :key="section_question.id"
                      class="list-group-item d-flex justify-content-between align-items-center py-2 px-2"
                    >
                      <div class="flex-grow-1 me-2 question-text-truncate">
                        <small class="d-block text-xxs text-truncate" :title="section_question.question?.question_text">
                          {{ truncate_text(section_question.question?.question_text, 45) }}
                        </small>
                        <span class="badge bg-light text-dark text-xxs">
                          {{ format_question_type(section_question.question?.question_type) }}
                        </span>
                      </div>
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="section_question.is_assigned"
                          :disabled="section_question.is_loading"
                          @change="toggle_question_assignment(section_question)"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-center py-3 text-muted text-xxs">No questions found.</div>
                </div>
              </div>
            </div>

            <!-- RIGHT: Assigned Questions -->
            <div class="col-lg-6">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="text-xs fw-bold mb-0">
                  <i class="fas fa-list-check me-2 text-success"></i>Assigned
                  <span class="badge bg-success ms-1">{{ total_assigned }}</span>
                </h6>
                <input type="text" class="form-control form-control-sm text-xxs w-50" placeholder="Search..." v-model="assigned_search" />
              </div>

              <div v-if="is_loading_assigned" class="text-center py-4">
                <div class="spinner-border spinner-border-sm"></div>
              </div>
              <div v-else-if="!total_assigned" class="text-center py-5">
                <i class="fas fa-inbox fa-2x text-muted mb-2"></i>
                <p class="text-muted text-xxs">No questions assigned.</p>
              </div>

              <!-- Tree View -->
              <div v-else-if="!assigned_search.trim()" class="assigned-tree assigned-tree-container">
                <div v-for="form in assigned_forms" :key="form.form_id" class="mb-2">
                  <div class="d-flex align-items-center bg-light rounded px-2 py-1 cursor-pointer" @click="toggle_collapse(`form_${form.form_id}`)">
                    <i class="fas me-2 text-xxs" :class="is_collapsed(`form_${form.form_id}`) ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
                    <i class="fas fa-file-alt me-2 text-primary text-xxs"></i>
                    <span class="text-xxs fw-medium">{{ form.form_name }}</span>
                    <span class="badge bg-secondary ms-auto text-xxs">{{ form.form_type }}</span>
                  </div>

                  <div v-show="!is_collapsed(`form_${form.form_id}`)" class="ms-3 mt-1">
                    <div v-for="main_section in form.main_sections" :key="main_section.main_section_id" class="mb-1">
                      <div
                        class="d-flex align-items-center bg-white border-start border-2 border-info px-2 py-1 cursor-pointer"
                        @click="toggle_collapse(`main_${form.form_id}_${main_section.main_section_id}`)"
                      >
                        <i class="fas me-2 text-xxs" :class="is_collapsed(`main_${form.form_id}_${main_section.main_section_id}`) ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
                        <i class="fas fa-folder me-2 text-info text-xxs"></i>
                        <span class="text-xxs">{{ main_section.main_section_name || "No Main Section" }}</span>
                      </div>

                      <div v-show="!is_collapsed(`main_${form.form_id}_${main_section.main_section_id}`)" class="ms-3 mt-1">
                        <div v-for="sub_section in main_section.sub_sections" :key="sub_section.sub_section_id" class="mb-1">
                          <div
                            class="d-flex align-items-center bg-white border-start border-2 border-warning px-2 py-1 cursor-pointer"
                            @click="toggle_collapse(`sub_${form.form_id}_${main_section.main_section_id}_${sub_section.sub_section_id}`)"
                          >
                            <i class="fas me-2 text-xxs" :class="is_collapsed(`sub_${form.form_id}_${main_section.main_section_id}_${sub_section.sub_section_id}`) ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
                            <i class="fas fa-folder-open me-2 text-warning text-xxs"></i>
                            <span class="text-xxs">{{ sub_section.sub_section_name }}</span>
                            <span class="badge bg-warning text-dark ms-auto text-xxs">{{ sub_section.questions.length }}</span>
                          </div>

                          <div v-show="!is_collapsed(`sub_${form.form_id}_${main_section.main_section_id}_${sub_section.sub_section_id}`)" class="ms-3 mt-1">
                            <div
                              v-for="question in sub_section.questions"
                              :key="question.id"
                              class="d-flex align-items-center bg-white border-start border-2 border-success px-2 py-1 mb-1"
                            >
                              <i class="fas fa-question-circle me-2 text-success text-xxs"></i>
                              <span class="text-xxs flex-grow-1 text-truncate assigned-question-text" :title="question.question_text">
                                {{ truncate_text(question.question_text, 35) }}
                              </span>
                              <span class="badge bg-light text-dark me-2 text-xxs">
                                {{ format_question_type(question.question_type) }}
                              </span>
                              <button class="btn btn-link btn-sm p-0 text-danger" @click.stop="unassign_question(question.id)" title="Remove">
                                <i class="fas fa-times text-xxs"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Flat Search View -->
              <div v-else class="list-group list-group-flush search-results-container">
                <div v-for="question in filtered_assigned_questions" :key="question.id" class="list-group-item py-2 px-2">
                  <div class="d-flex justify-content-between align-items-start">
                    <div class="flex-grow-1">
                      <small class="d-block text-xxs fw-medium" :title="question.question_text">
                        {{ truncate_text(question.question_text, 50) }}
                      </small>
                      <div class="mt-1">
                        <span class="badge bg-primary me-1 text-xxs">{{ question.form_name }}</span>
                        <span v-if="question.main_section_name" class="badge bg-info me-1 text-xxs">{{ question.main_section_name }}</span>
                        <span class="badge bg-warning text-dark text-xxs">{{ question.sub_section_name }}</span>
                      </div>
                    </div>
                    <button class="btn btn-link btn-sm p-0 text-danger ms-2" @click="unassign_question(question.id)" title="Remove">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div v-if="!filtered_assigned_questions.length" class="text-center py-3 text-muted text-xxs">No matches found.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>